import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {EditTeamService} from './edit-team.service';


@Injectable()
export class TeamSizeResolver {
  private team = inject(EditTeamService);
  
  // `null` when the seat count could not be read - resolving null keeps the navigation alive so the
  // screen can say so, instead of erroring and having Angular cancel the navigation silently.
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<number | null> {
    return this.team.loadTeamSize();
  }

}
